<template>
  <div class="main row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="'Chỉnh sửa ngân sách năm'">
        <template v-slot:preview>
          <BudgetLineDeclareForm
            :mode="'edit'"
            :disabled="isSaving"
            :showBack="true"
            :showSubmit="true"
            :submitText="'Lưu'"
            :initialValue="editInitialValue"
            @back="goBack"
            @submit="submitEdit"
          />
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, handleError } from '@/utils/common';
import BudgetLineDeclareForm from './components/BudgetLineDeclareForm.vue';
import moment from 'moment';

export default {
  components: { KTCodePreview, BudgetLineDeclareForm },
  data() {
    return {
      isSaving: false,
      parent: {},
      months: [],
      histories: [],
      editInitialValue: {},
    };
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      this.fetchDetail(id);
      this.fetchHistory(id);
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán', route: '#' },
      { title: 'Ngân sách', route: '/budget/budget-lines' },
      { title: 'Chỉnh sửa năm' },
    ]);
  },
  methods: {
    makeToastSuccess,
    buildInitialValue() {
      const byMonth = new Array(12).fill(0);
      (this.months || []).forEach((m) => {
        const idx = m?.period ? Number(moment(m.period).format('M')) - 1 : -1;
        if (idx >= 0 && idx < 12) byMonth[idx] = Number(m.allocatedAmount) || 0;
      });
      const yearLabel = this.parent?.period
        ? moment(this.parent.period).format('YYYY')
        : '';
      this.editInitialValue = {
        year: yearLabel ? Number(yearLabel) : undefined,
        companyId: this.parent?.companyId ?? null,
        departmentId: this.parent?.departmentId ?? null,
        departmentName: this.parent?.departmentName || '',
        costItemId: this.parent?.costItemId ?? null,
        costItemName: this.parent?.costItem?.name || '',
        storeId: this.parent?.storeId ?? null,
        storeName: this.parent?.storeName || '',
        monthAmounts: byMonth,
        description: this.histories?.[0]?.description || '',
      };
    },
    fetchDetail(id) {
      ApiService.get(`v2/budget-lines/parents/${id}/detail`)
        .then(({ data }) => {
          this.parent = data.data.parent || {};
          this.months = data.data.months || [];
          this.buildInitialValue();
        })
        .catch((err) => handleError(err));
    },
    fetchHistory(id) {
      ApiService.get(`v2/budget-lines/${id}/history`)
        .then(({ data }) => {
          this.histories = data.data || [];
          this.buildInitialValue();
        })
        .catch((err) => handleError(err));
    },
    submitEdit(payload) {
      const id = this.$route.query.id;
      if (!id) return;
      this.isSaving = true;
      ApiService.put(`v2/budget-lines/parents/${id}`, payload)
        .then(({ data }) => {
          this.makeToastSuccess(
            data.message || 'Cập nhật ngân sách năm thành công!',
          );
          this.goBack();
        })
        .catch((err) => handleError(err))
        .finally(() => {
          this.isSaving = false;
        });
    },
    goBack() {
      const id = this.$route.query.id;
      const from = this.$route?.query?.from;
      const q = { id };
      if (from) q.from = String(from);
      this.$router
        .push({ name: 'detail-budget-year-group', query: q })
        .catch(() => {});
    },
  },
};
</script>

